import { createCRUDHook } from './createCRUDHook';
import { ActivityDto } from 'utils/models';
import { CRM_ACTIVITY } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<ActivityDto>({
  entityName: 'Activity',
  endpoint: CRM_ACTIVITY,
});

export const ActivityContext = Context;
export const useActivityManager = useManager;
export const useActivity = useConsumer;
